
<script>
    import { Router, Route } from 'svelte-routing';
    import Homepage from './Homepage.svelte';
    import Minecraft from './Minecraft.svelte';
    import Factorio from './Factorio.svelte';
    import Valheim from './Valheim.svelte';
    import Discord from './Discord.svelte';
    import Navbar from '../Navbar.svelte';
    import Footer from '../components/Footer.svelte';
    import NotFound from '../routes/NotFound.svelte';
    export let url = '';
  </script>
  
<div style="background-color: #101032;">
    
    <Router {url}>
        <Navbar></Navbar>
  
    <div>
      <Route path="minecraft" component={Minecraft} />
      <Route path="factorio" component={Factorio} />
      <Route path="valheim" component={Valheim} />
      <Route path="discord" component={Discord} />
      <Route path="minecraft/" component={Minecraft} />
      <Route path="factorio/" component={Factorio} />
      <Route path="valheim/" component={Valheim} />
      <Route path="discord/" component={Discord} />
      <Route path="minecraft.html" component={Minecraft} />
      <Route path="factorio.html" component={Factorio} />
      <Route path="valheim.html" component={Valheim} />
      <Route path="discord.html" component={Discord} />
      <Route path="/" component={Homepage} />
      <Route path="/index" component={Homepage} />
      <Route path="/index.html" component={Homepage} />
      <Route path="*" component={NotFound} />
    </div>
        <Footer></Footer>
  </Router>

</div>